/**
 * @date: 12/3/20
 * @author: Yan Wang <ywang@max.md>
 * @copy: (C) Copyright 2020 MaxMD Corporation, All Rights Reserved.
 *
 */
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Container from "@mui/material/Container";
import React, { useState } from "react";
import makeStyles from '@mui/styles/makeStyles';
import clsx from "clsx";
import UserProfileWidget from "../profile/UserProfileWidget";
import RecentContributionsWidget from "../Contributions/RecentContributionsWidget";
import { Button } from "@mui/material";
import { PortalUrl } from "../utils/portal-urls";
import LastPublishChartsWidget from "../Charts/LastPublishChartsWidget";
import PublishedLeaderBoardDialog from "../Published/PublishedLeaderBoardDialog";
import { Link } from "react-router-dom";
import PublishedFewestErrorAndScore from "../Published/PublishedFewestErrorAndScore";
import ExternalSourceHomeWidget from "../ExternalSourceManagement/ExternalSourceHomeWidget";
import CurrentSyncWidget from "../Charts/CurrentSyncWidget";
import CurrentDirectoryFHIRInformationDialog from "./CurrentDirectoryFHIRInformationDialog";
import AvgIntervalWidget from "../Charts/AvgIntervalWidget";

const useStyles = makeStyles((theme) => ({
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        '& h3': {
            color: '#777777', fontSize: 19
        }
    },

    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        boxShadow: '0 7px 20px #cccccc'
    },
    fixedHeight: {
        height: 210,
    },
    fixedHeightLarge: {
        height: 450,
    },
    fixedMediumLarge: {
        height: 320,
    },
    minHeight: {
        minHeight: 120,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    link: {
        color: 'white',
    },
    viewButton: {
        marginLeft: 9
    },
    refreshButton: {
        marginLeft: 5,
        float: 'right'
    },
}));
export default function UserHomeContent(props) {
    console.log(props.account);
    const account = props.account;
    const { user, organization } = props.account;
    // console.log('user,org: ', user, organization);
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const fixedHeightMediumPaper = clsx(classes.paper, classes.fixedMediumLarge);
    const fixedHeightLargePaper = clsx(classes.paper, classes.fixedHeightLarge);
    const dynamicHeightPaper = clsx(classes.paper, classes.minHeight);

    const [visitsRefresh, setVisitsRefresh] = useState(0);
    const [adtsRefresh, setAdtsRefresh] = useState(0);

    // leader board
    const [leaderBoardOpen, setLeaderBoardOpen] = useState(false);

    // fhir info detail
    const [fhirInfoDialogOpen, setFhirInfoDialogOpen] = useState(false);


    return (
        <Container maxWidth='xl' className={classes.container}>
            <PublishedLeaderBoardDialog
                setLeaderBoardOpen={(c) => setLeaderBoardOpen(c)}
                leaderBoardOpen={leaderBoardOpen}
            />
            {fhirInfoDialogOpen &&
                <CurrentDirectoryFHIRInformationDialog
                    fhirInfoDialogOpen={fhirInfoDialogOpen}
                    setFhirInfoDialogOpen={(s) => setFhirInfoDialogOpen(s)}
                />
            }

            <h3 className='title'>
                Home Dashboard
            </h3>
            <Grid container spacing={3}>
                <Grid item xs={12} md={4} lg={4}>
                    <h3 style={{ height: '36.5px' }}>Profile</h3>
                    {/*<h3>User Info</h3>*/}
                    {/*<Paper className={fixedHeightPaper}>*/}
                    <Paper className={fixedHeightMediumPaper}>
                        <UserProfileWidget user={user}/>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={8} lg={8}>
                    <h3 style={{ height: '36.5px' }}>Recent External DataSource Maintenance Tasks</h3>
                    <Paper className={fixedHeightMediumPaper}>
                        <ExternalSourceHomeWidget/>
                    </Paper>

                </Grid>


                {/*<Grid item xs={12} md={8} lg={8}>*/}
                {/*    <h3>Recent Audit Logs*/}
                {/*        /!*<Button href={PortalUrl.AuditLogs.Home.pattern}>View Details</Button>*!/*/}
                {/*        <Button component={Link} to={PortalUrl.AuditLogs.Home.pattern}>View Details</Button>*/}
                {/*    </h3>*/}
                {/*    <Paper className={fixedHeightMediumPaper}>*/}
                {/*        <RecentAuditLogsWidget />*/}
                {/*    </Paper>*/}
                {/*</Grid>*/}

                <Grid item xs={12} md={12} lg={12}>
                    <h3>Current Directory CSV Publication
                        {/*<Button href={PortalUrl.Published.Publication.getPath("last")}>View Details</Button>*/}
                        {/*<Button startIcon={<LeaderboardIcon />} onClick={() => setLeaderBoardOpen(true)}>View Leader Board</Button>*/}
                        <Button component={Link} to={PortalUrl.Published.Publication.getPath("last")}>View
                            Details</Button>
                    </h3>
                    <Paper className={fixedHeightMediumPaper} style={{ height: 400, overflow: 'hidden' }}>
                        <LastPublishChartsWidget/>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                    <h3>
                        Current Directory FHIR Information
                        <Button onClick={() => setFhirInfoDialogOpen(true)}>View Details</Button>
                    </h3>
                    <Paper className={fixedHeightMediumPaper} style={{ height: 400, overflow: 'hidden' }}>
                        <CurrentSyncWidget/>
                    </Paper>

                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                    <h3>HISP Activity Intervals</h3>
                    <Paper className={dynamicHeightPaper}>
                        <AvgIntervalWidget/>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                    <h3>Data Quality</h3>
                    <PublishedFewestErrorAndScore/>
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                    <h3>Recent Contributions
                        <Button component={Link} to={PortalUrl.Contributions.Home.pattern}>View Details</Button>
                    </h3>
                    <Paper className={fixedHeightLargePaper}>
                        <RecentContributionsWidget/>
                    </Paper>
                </Grid>
            </Grid>
        </Container>
    );
}
